<template>
<div>
    <!-- 寻物雷达 -->
    <el-dialog class="detailwrap" :visible.sync="radarVisible" :before-close="radar_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
        <div class="detailbg">
            <center><font color="ff0000" class="title">寻物雷达</font></center>
			<hr color="000000">
			<div class="noTreasureList" v-if="null == fantasyTreasureBO">
				寻物雷达未设置，可以去探索工会看看有没有新的小道消息
			</div>
			<el-row v-if="null != fantasyTreasureBO">
				<el-col :span="4">
					<span v-if="fantasyTreasureBO.itemStatus==0"></span>
					<span v-else><img v-if="fantasyTreasureBO.itemStatus==1" :title="fantasyTreasureBO.name" :src="ossPath + fantasyTreasureBO.imgsrc"></span>
				</el-col>
				<el-col :span="16">
					<div class="detailLine">
						<span class="detailLabel">道具名称：</span>
						<span v-if="fantasyTreasureBO.itemStatus==0" class="detailValue">神秘物品</span>
						<span v-else class="detailValue">{{fantasyTreasureBO.name}}</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">描述：</span>
						<span v-if="fantasyTreasureBO.itemStatus==0" class="detailValue">未知</span>
						<span v-else class="detailValue">{{fantasyTreasureBO.itemDesc}}</span>
					</div>
					<div class="detailLine">
						<span class="detailLabel">失主：</span>
						<span v-if="fantasyTreasureBO.itemStatus==0" class="detailValue">未知</span>
						<span v-else class="detailValue">{{fantasyTreasureBO.npcName}}</span>
					</div>
					<div v-if="fantasyTreasureBO.itemStatus==0 && !crossCityTip" class="detailLine">
						<span class="detailLabel">方位：</span>
						<span class="detailValue">{{directionStr}}</span>
					</div>
					<div v-if="fantasyTreasureBO.itemStatus==0 && !crossCityTip" class="detailLine">
						<span class="detailLabel">距离：</span>
						<span class="detailValue">{{distanceStr}}</span>
					</div>
					<!-- 跨城雷达提醒（2026-11-05）：宝物刷在别的城市时，方位/距离是假信号，改给明确提醒 -->
					<div v-if="fantasyTreasureBO.itemStatus==0 && crossCityTip" class="detailLine">
						<span class="detailLabel">提醒：</span>
						<span class="detailValue" style="color:#e53935;">{{crossCityTip}}</span>
					</div>
					<!-- 寻物雷达改造（2026-10-15）：委托有到期时刻（默认"今日 24:00"） -->
					<div v-if="deadlineDesc" class="detailLine">
						<span class="detailLabel">交付期限：</span>
						<span class="detailValue" style="color:#e53935;">{{deadlineDesc}}前{{
							fantasyTreasureBO.itemStatus==1 ? '交给' + fantasyTreasureBO.npcName : ''
						}}</span>
					</div>
				</el-col>
				<!-- 已挖到后不再提供"放弃"入口：宝物已在背包里，放弃会销毁道具（交付任务自身可拒绝） -->
				<el-col :span="4">
					<a v-if="fantasyTreasureBO.itemStatus==0" @click="rejectTreasureTask(fantasyTreasureBO.id);">放弃委托</a>
				</el-col>
			</el-row>
		</div>
    </el-dialog>
	
</div>
</template>

<script>
import {postRequest} from '../../utils/api'
import {getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
	name: 'radar',
	props:{
		radarVisible: {
		type: Boolean,
		default: false
		},
		fantasyUserBO: Object,
	},
	data() {
		return {
			resultCode: "",
			directionStr: "",
			distanceStr: "",
			deadlineDesc: "",
			crossCityTip: "",
			loading: false,
			fantasyTreasureBO: {}
		};
	},
	computed: {
	},
	watch: {
		radarVisible: {
			handler(newVal) {
				if (newVal === true) {
					this.openRadar();
				}
			}
		}
	},
	mounted: function () {
		if (this.radarVisible) {
			this.openRadar();
		}
	},
	methods: {
		radar_dialog_close() {
			this.$emit("radar_dialog_close");
		},
		
		//开启寻物雷达
		openRadar: function(){
			this.resultCode = "";
			this.directionStr = "";
			this.distanceStr = "";
			this.deadlineDesc = "";
			this.crossCityTip = "";
			this.loading = true;
			this.fantasyTreasureBO = {};
			//开启寻物雷达
			getRequest('/item/treasure/openRadar', {
			}).then(resp=> {
				this.loading = false;
				if (resp.status == 200) {
				//成功
				var respData = resp.data;
				if (200 == respData.status) {
					if (null != respData.data.resultCode) {
						this.resultCode = respData.data.resultCode;
					}
					if (null != respData.data.directionStr) {
						this.directionStr = respData.data.directionStr;
					}
					if (null != respData.data.distanceStr) {
						this.distanceStr = respData.data.distanceStr;
					}
					if (null != respData.data.deadlineDesc) {
						this.deadlineDesc = respData.data.deadlineDesc;
					}
					if (null != respData.data.crossCityTip) {
						this.crossCityTip = respData.data.crossCityTip;
					}
					if (null != respData.data.fantasyTreasureBO) {
						this.fantasyTreasureBO = respData.data.fantasyTreasureBO;
					}
				} else {
					this.fantasyTreasureBO = null;
					// 线索已过期等：把后端提示透出，别让玩家对着空白窗口发呆
					if (respData.message) {
						Message.error(respData.message);
					}
				}
				} else {
				//失败
				Message.error('开启寻物雷达失败');
				}
			}, resp=> {
				Message.error('开启寻物雷达异常');
			});
		},
    rejectTreasureTask: function(value) {
        var _this = this;
        this.$confirm('放弃后这条线索会重新流回探索工会，确定放弃吗？', '提示', {
            confirmButtonText: '确定放弃',
            cancelButtonText: '再想想'
        }).then(function () {
            postRequest('/item/treasure/rejectTreasureTask', {
                treasureId: value
            }).then(resp=> {
                if (resp.status == 200) {
                    //成功
                    var respData = resp.data;
                    if (200 == respData.status) {
                        _this.treasureListVisible = true;
                        _this.fantasyTreasureBO = null;
                        _this.deadlineDesc = "";
                        Message.success(respData.message || "您已成功取消寻物任务。");
                    } else {
                        Message.error(respData.message);
                    }
                } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!');
                }
            }, resp=> {
                Message.error('用户非法⊙﹏⊙∥!');
            });
        }, function () {
            //取消
        });
    },
	}
}
</script>

<style >
.detailwrap {
    margin:auto;
    width: 80%;
}
.el-dialog {
	background: #fdffea;
}
.detailbg {
    background: #fdffea;
}

.title {
    font-size: 20px;
    line-height: 40px;
}
.noTreasureList {
    padding:3px 5px;
    font-size:12px;
    font-weight:bold;
    letter-spacing:5px;
    text-align:center;
    height: 100px;
    line-height: 100px;
}


.detailTitle {
    color: #70afbe;
}
.detailLabel {
    color: #7d7a75;
}
.detailValue {
    color: #92655f;
}
.detailwrap .nickName {
	width: 100px;
}
.detailwrap hr {
	margin-top: 5px;
	margin-bottom: 5px;
}
.detailLine {
	line-height: 30px;
}
.detailwrap .password {
	width: 150px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .detailwrap {
    /* 确保 dialog 宽度被 App.vue 全局样式覆盖，不额外限制 */
    width: auto !important;
    margin: 0 !important;
  }
  .detailwrap .el-dialog__body {
    min-height: 50vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .detailbg {
    width: 100%;
    text-align: center;
  }
  .detailbg .title {
    font-size: 18px;
    line-height: 36px;
  }
  .noTreasureList {
    height: auto;
    line-height: 1.8;
    padding: 24px 20px;
    font-size: 14px;
    letter-spacing: 2px;
  }
  .detailLine {
    line-height: 28px;
    font-size: 13px;
    text-align: left;
  }
  .detailLabel {
    display: inline-block;
    min-width: 70px;
  }
}

</style>